import { __assign, __rest } from "tslib";
import React from 'react';
import { CnDatePickerPro as PCCnDatePickerPro, CnMonthPickerPro as PCCnMonthPickerPro, CnYearPickerPro as PCCnYearPickerPro, CnWeekPickerPro as PCCnWeekPickerPro, CnQuarterPickerPro as PCCnQuarterPickerPro, CnRangeDatePickerPro as PCCnRangeDatePickerPro, } from '@cainiaofe/cn-ui';
export { CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnQuarterPickerPro, } from '@cainiaofe/cn-ui';
export var CnDatePicker = function (props) {
    var precision = props.precision, restProps = __rest(props, ["precision"]);
    var componet = React.createElement(PCCnDatePickerPro, __assign({}, props));
    /** 精度设置："year" | "month" | "day" | "hour" | "minute" | "second" | "week" | "week-day" */
    if (precision === 'month') {
        componet = React.createElement(PCCnMonthPickerPro, __assign({}, restProps));
    }
    else if (precision === 'year') {
        componet = React.createElement(PCCnYearPickerPro, __assign({}, restProps));
    }
    else if (precision === 'week') {
        componet = React.createElement(PCCnWeekPickerPro, __assign({}, restProps));
    }
    else if (precision === 'quarter') {
        componet = React.createElement(PCCnQuarterPickerPro, __assign({}, restProps));
    }
    else if (precision === 'hour') {
        componet = (React.createElement(PCCnDatePickerPro, __assign({ showTime: true }, restProps, { format: 'YYYY-MM-DD HH' })));
    }
    else if (precision === 'minute') {
        componet = (React.createElement(PCCnDatePickerPro, __assign({ showTime: true }, restProps, { format: 'YYYY-MM-DD HH:mm' })));
    }
    else if (precision === 'second') {
        componet = (React.createElement(PCCnDatePickerPro, __assign({ showTime: true }, restProps, { format: 'YYYY-MM-DD HH:mm:ss' })));
    }
    return componet;
};
export var CnDatePickerPro = CnDatePicker;
export var CnDateRangePickerPro = function (props) {
    return React.createElement(PCCnRangeDatePickerPro, __assign({}, props));
};
export var CnRangeDatePickerPro = CnDateRangePickerPro;
